import type { Resource } from '../../';
export const general_errors_renderAlerts_title_inHydrationDev: Resource = {"default":"Component \"{componentName}\" failed to hydrate."};
